export default {
  name: 'AuthorSection',
  props: {
    number: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    isStacked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedNumber() {
      return String(this.number).padStart(2, '0');
    }
  }
};
